module.exports = __webpack_public_path__ + "img/vertical_3_4_6005.d1186e2f.png";